import './MenuList.less';

export const prefix = 'oc-c-menu-list';

export { default } from './MenuList';
